var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F1F1F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_28378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.377 7.37924L13.9177 6.83856C14.8135 5.94273 16.266 5.94273 17.1618 6.83856C18.0576 7.73438 18.0576 9.18681 17.1618 10.0826L16.6211 10.6233M13.377 7.37924C13.377 7.37924 13.4446 8.52818 14.4584 9.54196C15.4722 10.5557 16.6211 10.6233 16.6211 10.6233M13.377 7.37924L8.40631 12.35C8.06963 12.6866 7.90129 12.855 7.75652 13.0406C7.58574 13.2595 7.43932 13.4965 7.31986 13.7471C7.21859 13.9596 7.1433 14.1855 6.99274 14.6372L6.35471 16.5512M16.6211 10.6233L11.6504 15.594C11.3137 15.9307 11.1454 16.0991 10.9598 16.2438C10.7408 16.4146 10.5039 16.561 10.2532 16.6805C10.0407 16.7818 9.81488 16.857 9.36318 17.0076L7.44911 17.6456M7.44911 17.6456L6.98123 17.8016C6.75895 17.8757 6.51388 17.8178 6.34819 17.6522C6.18251 17.4865 6.12466 17.2414 6.19875 17.0191L6.35471 16.5512M7.44911 17.6456L6.35471 16.5512",
    stroke: "#252525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_28378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.17abc715278be40e54acd171a2c320e8.svg";
export { ForwardRef as ReactComponent };